<script setup>
  const props = defineProps({
    distance: { default: '0', type: String },
    scrollTarget: { type: Object }
  })

  const emit = defineEmits(['loadMore'])

  const line = ref(null)

  const visible = useElementVisibility(line, props.scrollTarget ? { scrollTarget: props.scrollTarget } : {})

  whenever(visible, () => {
    emit('loadMore')
  })
</script>

<template>
  <div>
    <slot />

    <div class="relative">
      <div
        class="absolute inset-0 h-full w-full"
        :style="{
          top: props.distance
        }"
        ref="line"
      />
    </div>
  </div>
</template>
